import React from 'react';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import PropTypes from 'prop-types';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import TextButton from 'Components/ComponentLibrary/Components/Uncategorized/TextButton';

import RoundedButton from 'Components/ComponentLibrary/Components/Uncategorized/RoundedButton';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import useMobileLayout from 'Hooks/useMobileLayout';
import AccountSetupSection from '../../Components/AccountSetup/AccountSetupSection';
import SurveyFixedFooterActions from '../../../SurveyFixedFooterActions';
import { useSurveyStepContext } from '../../SurveyStepContext';
import ResendCodeButtonPicker from './ResendCodeButtonPicker';

const styles = (theme) => ({
  root: {},
  footer: {},
  enableButton: {
    marginTop: theme.spacing(1),
  },
});

const AccountSetupTwoFactorAuthenticationVerificationLayout = ({
  classes,
}) => {
  const {
    resource,
    onSubmit: onSubmitMetaForm,
  } = useMetaLayoutContext();

  const {
    onClickNext,
    onClickPrevious,
  } = useSurveyStepContext();

  const isMobile = useMobileLayout();

  return (
    <div className={classes.root}>
      {/* ---------- Section title / icon / message ---------- */}
      <AccountSetupSection
        title={'Two-Factor Authentication'}
        messages={[
          'Enter your Facet verification code.',
        ]}
        showFacetIcon
      />

      {/* ---------- Verification Code Input ---------- */}
      <MetaControlField
        attr={'verificationCode'}
        test={'confirm-2fa-code-input'}
      />

      {/* ---------- "Send code again" Button ---------- */}
      <ResendCodeButtonPicker
        onboardingStepResource={resource}
      />

      {/* ---------- Footer (Submit / cancel) ---------- */}
      <SurveyFixedFooterActions>
        <TextButton
          onClick={onClickPrevious}
          color={'primary'}
          weight={'bold'}
          fullWidth
          size={!isMobile ? 'lg' : 'md'}
          test={'cancel-confirm-2fa-code-button'}
        >
          {'Go Back'}
        </TextButton>
        <RoundedButton
          disabled={!resource.isValid()}
          className={classes.enableButton}
          onClick={() => onClickNext(onSubmitMetaForm)}
          color={'primary'}
          variant={'contained'}
          disableElevation
          fullWidth
          test={'confirm-2fa-code-button'}
        >
          {'Confirm'}
        </RoundedButton>
      </SurveyFixedFooterActions>
    </div>
  );
};

AccountSetupTwoFactorAuthenticationVerificationLayout.propTypes = {
  classes: PropTypes.object.isRequired,
};

AccountSetupTwoFactorAuthenticationVerificationLayout.defaultProps = {
};

export default withStyles(styles)(AccountSetupTwoFactorAuthenticationVerificationLayout);
